import React, { useCallback, useRef, useState } from 'react'
import { Avatar, Flexbox } from '@/components'
import upload from '@/services/api/upload'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import { AvatarWrapper, AvatarOverlay, HiddenInput } from '../../styles'

function AvatarUpload({ name, currentPhotoURL, onPhotoUploaded }) {
  const [uploading, setUploading] = useState(false)
  const fileInputRef = useRef(null)

  const handleAvatarClick = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  const handleFileChange = useCallback(async (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    try {
      setUploading(true)
      const { data: { url } } = await upload.sendFile(file)
      onPhotoUploaded(url)
    } catch {
      toast.error('Erro ao enviar a foto')
    } finally {
      setUploading(false)
      e.target.value = ''
    }
  }, [onPhotoUploaded])

  return (
    <Flexbox.Column className="col-12 text-center mb-2">
      <AvatarWrapper onClick={handleAvatarClick}>
        <Avatar
          avatarSize="xl"
          name={name}
          photoURL={currentPhotoURL}
          alt="Foto de perfil"
        />
        <AvatarOverlay>
          {uploading
            ? <i className="loading" />
            : <i className="fas fa-camera" />}
        </AvatarOverlay>
        <HiddenInput
          ref={fileInputRef}
          onChange={handleFileChange}
        />
      </AvatarWrapper>
      <div className="text-gray text-small mt-1">
        Clique para alterar a foto
      </div>
    </Flexbox.Column>
  )
}

AvatarUpload.propTypes = {
  name: PropTypes.string,
  currentPhotoURL: PropTypes.string,
  onPhotoUploaded: PropTypes.func.isRequired,
}

AvatarUpload.defaultProps = {
  name: '',
  currentPhotoURL: null,
}

export default AvatarUpload
